/*
 * Which organization the person was in, carried on our own links between
 * apps (`?org=<name>`), so the next app's silent sign-in asks Keycloak for
 * that organization (`organization:<name>`) instead of showing its picker a
 * second time. A HINT only: Keycloak mints a token for the organization only
 * if the person belongs to it, and a hint it rejects (a deleted org) is
 * dropped by the app's own invalid_scope handling, which then asks plainly.
 * Signup only writes the hint; the receiving app adopts it.
 */
// Organization names as signup makes them: lower-case letters, digits, dashes.
const NAME = /^[a-z0-9][a-z0-9-]{0,62}$/;

/** `url` with the current organization as a hint, for a link to another of our apps. */
export function withOrgHint(url: string, orgName?: string): string {
    if (!orgName || !NAME.test(orgName)) return url;
    try {
        const u = new URL(url);
        u.searchParams.set('org', orgName);
        return u.toString();
    } catch {
        return url;
    }
}
